import React, { useState, useEffect, useMemo } from 'react';
import { AlertBanner, AlertBannerDescription } from '@hpstellar/core/visId';
import uniqueBy from 'lodash/uniqBy';

import { withError } from '../../../shared/components/error-boundary';
import useCartState from '../../../hooks/useCartState';
import { Helpers } from '../../../core/src/helpers';
import { BLOCK_ERROR_CLASS } from '../cart-items/useAlerts';

export default withError(({}) => {
    const { cartInfo } = useCartState();
    const { cartDetails, ajaxError = [] } = cartInfo || {};
    const [closedMessage, setClosedMessage] = useState([]);
    const { cartLevelErrorMessages = [] } = cartDetails || {};

    const distinctErrors = useMemo(() => {
        const combinedErrors = [...cartLevelErrorMessages, ...ajaxError];
        return uniqueBy(combinedErrors, o => o.message);
    }, [JSON.stringify(ajaxError), JSON.stringify(cartLevelErrorMessages)]);

    const errorKey = distinctErrors.map(e => e.message).join(',');

    useEffect(() => {
        setClosedMessage([]);
    }, [errorKey]);

    if (distinctErrors?.length <= 0) {
        return null;
    }
    return (
        <div className="error-message-container">
            {distinctErrors.map((error, index) => {
                const { message, checkoutButtonDisabled } = error || {};
                if (closedMessage[index] || !message) {
                    return null;
                }
                const checkoutDisabled = checkoutButtonDisabled === 'true';

                const closeBtnProps = !checkoutDisabled
                    ? {
                          onClick: () => {
                              const newState = [...closedMessage];
                              newState[index] = true;
                              setClosedMessage(newState);
                          },
                          hasBorder: true,
                      }
                    : undefined;

                return (
                    <AlertBanner
                        className={`message${checkoutDisabled ? ' ' + BLOCK_ERROR_CLASS : ''}`}
                        key={index}
                        theme="secondary"
                        closeBtnProps={closeBtnProps}
                    >
                        <AlertBannerDescription dangerouslySetInnerHTML={Helpers.createMarkup(message)} />
                    </AlertBanner>
                );
            })}
        </div>
    );
});
